

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import { getQueryString,setItem,getItem,removeItem,tipShow,showLoading,hideLoading } from "./common/js/util";
import Api from './config';
import wx from 'weixin-js-sdk';
import { getOpenId,IsFocus,getVaildToken,getWxConfig } from "./api";
import store from './store'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Picker from 'vux/src/components/picker/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XAddress from 'vux/src/components/x-address/index.vue'

Vue.use(LoadingPlugin)
Vue.use(Group)
Vue.use(Cell)
Vue.use(XInput)
Vue.use(XButton)
Vue.use(ToastPlugin)
Vue.use(Swiper)
Vue.use(Scroller)
Vue.use(LoadMore)
Vue.use(Datetime)
Vue.use(Checker)
Vue.use(CheckerItem)
Vue.use(Picker)
Vue.use(PopupPicker)
Vue.use(XDialog)
Vue.use(Tab)
Vue.use(TabItem)
Vue.use(XAddress)

FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];

router.beforeEach(function (to, from, next) {
const bgc = to.meta && to.meta.bgc;
const pageType = to.meta && to.meta.pageType;

if (bgc) {
store.commit('setBgc', bgc);
}
if (pageType) {
store.commit('setPgT', pageType);
}
let timestamp = Date.parse(new Date())/1000;
let noncestr = 'zqzycrm'+parseInt(Math.random()*100000000);
let url = encodeURIComponent(location.href.split('#')[0]);

let signData = {
noncestr:noncestr,
timestamp:timestamp,
url:url
}
getVaildToken()
.then(res => {
if (res.errorCode == '0000') {
setItem('access_token',res.access_token)
let configDate = {
access_token:res.access_token,
data:JSON.stringify(signData)
}
getWxConfig(configDate)
.then(res => {
if (res.errorCode == '0000') {
wx.config({
debug: false,
appId:Api.wxAppid,
timestamp: timestamp,
nonceStr: noncestr,
signature: res.signature,
jsApiList: ['getLocation','addCard','updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage','onMenuShareTimeline'],
openTagList: ['wx-open-launch-weapp']

});
wx.error(function(res){
console.log(res)

});
}
})
}
})
let openid = getItem('openid');
let code = getQueryString('code');
























let token = getItem('token');



if (!token || token == '' || token == undefined) {





if (to.name === 'Login' || to.name == 'pwdLogin'  || to.name == 'forgetPwd'  || to.name == 'Registered' || to.name == 'userNote' || to.name == 'getLocation') {
next();
}else{
next({
path: '/Login'
})
}
} else {
if (to.name === 'Login' || to.name == 'pwdLogin'  || to.name == 'forgetPwd'  || to.name == 'Registered' || to.name == 'userNote' || to.name == 'getLocation' ) {
next({
path: '/userCenter'
})
}else{
next();
}
}

let companyId = getItem('companyId'),sharename = getItem('memberId');
wx.ready(function () {
wx.onMenuShareAppMessage({
title: '新华优选', // 分享标题
link: Api.shareUrl+'Login?sharename='+sharename,
desc: '河北省新华书店会员中心',
imgUrl: Api.shareUrl+'share_logo.jpg',
success:function(res){

},fail:function(err){
}
});
wx.onMenuShareTimeline({
title: '新华优选', // 分享标题
link: Api.shareUrl+'Login?sharename='+sharename,
desc: '河北省新华书店会员中心',
imgUrl: Api.shareUrl+'share_logo.jpg',
success:function(res){

},fail:function(err){

}
});





















})
})

router.afterEach(function (to) {

})

/* eslint-disable no-new */
new Vue({
store,
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js